import {models, Page, Report} from 'powerbi-client';
import {
  CUSTODIAN_DETAILS_VISUAL_TITLE,
  POWER_BI_VISUAL_SELECTOR_SCHEMA,
} from './constant';

const resolveActivePage = async (
  report: Report,
  pageFromEvent?: Page
): Promise<Page | undefined> => {
  if (typeof pageFromEvent?.getVisuals === 'function') {
    return pageFromEvent;
  }

  const pages = await report.getPages();
  return pages?.find((page) => page.isActive);
};

export const hideCustodianDetailsExportData = async (
  report: Report | null,
  pageFromEvent?: Page
): Promise<void> => {
  if (!report) return;

  try {
    const activePage = await resolveActivePage(report, pageFromEvent);
    if (!activePage) return;

    const visuals = await activePage.getVisuals();
    const matchingVisuals = visuals?.filter(
      (visual) => visual.title === CUSTODIAN_DETAILS_VISUAL_TITLE
    );

    for (const visual of matchingVisuals ?? []) {
      await report.updateSettings({
        commands: [
          {
            exportData: {
              displayOption: models.CommandDisplayOption.Hidden,
              selector: {
                $schema: POWER_BI_VISUAL_SELECTOR_SCHEMA,
                visualName: visual.name,
              },
            },
          },
        ],
      });
    }
  } catch (error) {
    console.error(
      'Failed to hide Export Data on Custodian Details visual:',
      error
    );
  }
};
